import { useId, useState, type InputHTMLAttributes } from 'react';
import { Eye, EyeOff } from 'lucide-react';

type PasswordInputProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'type'> & {
  showLabel?: string;
  hideLabel?: string;
};

const PasswordInput = ({
  id,
  className = '',
  showLabel = 'Show password',
  hideLabel = 'Hide password',
  ...props
}: PasswordInputProps) => {
  const generatedId = useId();
  const inputId = id ?? generatedId;
  const [isVisible, setIsVisible] = useState(false);
  const toggleLabel = isVisible ? hideLabel : showLabel;

  return (
    <span className="relative block w-full">
      <input
        {...props}
        id={inputId}
        type={isVisible ? 'text' : 'password'}
        className={className}
      />
      <button
        type="button"
        aria-label={toggleLabel}
        aria-controls={inputId}
        aria-pressed={isVisible}
        title={toggleLabel}
        onClick={() => setIsVisible((current) => !current)}
        className="absolute right-2 top-1/2 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full text-slate-500 transition hover:bg-slate-100 hover:text-slate-800 focus:outline-none focus:ring-2 focus:ring-emerald-400"
      >
        {isVisible ? <EyeOff className="h-5 w-5" aria-hidden="true" /> : <Eye className="h-5 w-5" aria-hidden="true" />}
      </button>
    </span>
  );
};

export default PasswordInput;
